import "./App.css";
import { Routes, Route } from "react-router-dom";
import { Home, HowToPlay } from "./pages";
import { Navbar } from "./components/Navbar/Navbar";
import { PageHead } from "./components/PageHead/PageHead";
import { CC100 } from "./pages/CC100/CC100";
import { TradingAccount } from "./pages/TradingAccount/TradingAccount";
import { PremiumAccount } from "./pages/PremiumAccount/PremiumAccount";
import { ProfitLoss } from "./pages/ProfitLoss/ProfitLoss";
import { KOTTO } from "./pages/KOTTTO/KOTTO";
import { PLP } from "./pages/PLP/PLP";
import { Leaderboard } from "./pages/Leaderboard/Leaderboard";
import { AuthProvider } from "./context/auth";
import { Footer } from "./components/Footer/Footer";
import { Login } from "./pages/Login/Login";
import { Register } from "./pages/Register/Register";
import { GameLog } from "./pages/Gamelog/GameLog";
import { ScrollHandler } from "./components/ScrollHandler";
import { Toaster } from "react-hot-toast";

function App() {
  return (
    <ScrollHandler>
      <Toaster />
      <div className="app-lyt-wrapper">
        <AuthProvider>
          <div className="sticky-head">
            <PageHead />
            <Navbar />
          </div>
          <div className="app-lyt-main">
            <Routes>
              <Route
                path="/"
                element={<Home />}
                onEnter={() => console.log("We are in home route")}
              />
              <Route path="how-to-play" element={<HowToPlay />} />
              <Route path="cc-100-list" element={<CC100 />} />
              <Route path="ko-100" element={<Leaderboard />} />
              <Route path="game-log" element={<GameLog />} />
              <Route path="/account/trading" element={<TradingAccount />} />
              <Route path="/account/premium" element={<PremiumAccount />} />
              <Route path="/account/plp" element={<PLP />} />
              <Route path="/account/kotto" element={<KOTTO />} />
              <Route path="/account/profit-loss" element={<ProfitLoss />} />
              <Route path="/login" element={<Login />} />
              <Route path="/join" element={<Register />} />
            </Routes>
            <Footer />
          </div>
        </AuthProvider>
      </div>
    </ScrollHandler>
  );
}

export default App;
